module.exports = __webpack_public_path__ + "static/img/restaurant-view-tabs04.b8f8adb4.svg";